import { splitterIDs } from "../../../../settings";
import { ComponentTypes } from "../../../ComponentFactory/types";


export const SplitterConfig = {
    rows: splitterIDs.map((num: number) => {
        return  {
            name: `1x${num}`,
            type: ComponentTypes.INPUT,
            id: `splitters_loss_1x${num}`,
            valueID: "gain_loss",
            step: 0.1,
            measure: 'dB'
        }
    })
}